import {GroupedData} from "../../../data-structures/group"
import FieldProto from "../../../fields3/proto/field-proto"
import TaskFields from "../task-fields"
import {SEPARATOR} from "../../../gd-components/popover-menu/const"

// const debug = "taskFields_structureGroupByFields"
const debug = false

export default function taskFields_structureGroupByFields(taskFields: TaskFields, excludeFieldIds?: ID[]):GroupedData {

    // taskFields.initAllCustomFields()
    const groupByCustomFields = _.filter(taskFields.customFields(), (field:FieldProto)=>{
        return field.isGroupByAvailable && (!excludeFieldIds || !excludeFieldIds.includes(field.fieldId))
    })

    const filterItems = (items: (FieldProto | string)[]) => {
        debug && console.log(debug, 'filterItems', items, excludeFieldIds)

        return _.filter(items, (item: FieldProto | string) => {
            return typeof item === 'string' || !excludeFieldIds || !excludeFieldIds.includes(item.fieldId)
        })
    }

    return [
        {
            value   : 'general',
            label   : 'General',
            type    : 'system',
            items   : filterItems([
                taskFields.statusId,
                taskFields.systemStatus,
                taskFields.projectId,
                taskFields.priority,
                taskFields.taskTypeId,
            ])
        },
        {
            value   : 'users',
            label   : 'Users',
            type    : 'system',
            items   : filterItems([
                taskFields.actionRequiredUserId,
                taskFields.assignedToUserId,
            ])
        },
        {
            value   : 'dates',
            label   : 'Dates',
            type    : 'system',
            items   : filterItems([
                taskFields.deadline,
                taskFields.startDate,
                taskFields.endDate,
                taskFields.scheduleDate,
                SEPARATOR,
                taskFields.momentCreated,
                taskFields.momentClosed,
                taskFields.latestActivityMoment,
            ])
        },
        {
            value   : 'estimate',
            label   : 'Estimate',
            type    : 'system',
            items   : filterItems([
                taskFields.storyPoints
            ])
        },
        {
            value   : 'custom-fields', // DO NOT CALL IT 'custom'!!!!
            label   : 'Custom',
            type    : 'custom-fields',
            items   : groupByCustomFields
        }
    ]

}